import { defineComponent as w, ref as f, computed as n, toRef as P, openBlock as p, createElementBlock as T, normalizeClass as v, withModifiers as D, Fragment as G, createTextVNode as k, toDisplayString as V, resolveComponent as N, createElementVNode as E, renderList as L, createBlock as A, withCtx as U, createVNode as F, renderSlot as Q, watch as j, nextTick as te, createCommentVNode as oe } from "vue";
import { DropdownClose as re, DropdownOpen as ne } from "@onereach/ui-components-common/directives";
import { useProxyModelValue as R, useDateMask as ae, useTimeMask as ie, useDateFormat as le, useTimeFormat as ue, useLocale as se, useResponsive as de } from "@onereach/ui-components-common/hooks";
import { O as me } from "./OrError-B5ihH6-3.mjs";
import { O as ce } from "./OrHint-NvbZyURY.mjs";
import { O as X } from "./OrIconButton-BlHCLpeW.mjs";
import { O as _ } from "./OrIcon-k8cyvh-D.mjs";
import { O as pe } from "./OrInputBox-6ciokFdU.mjs";
import { a as fe } from "./OrInputBox.vue_vue_type_script_lang-q2L7rmth.mjs";
import { O as x } from "./OrLabel-DssheqEn.mjs";
import { O as ye } from "./OrPopover-DbygLPtT.mjs";
import "@onereach/ui-components-common/utils";
import { TimeFormat as Y } from "@onereach/ui-components-common/types";
import { _ as q } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
import { O as W } from "./OrButton-C_hXddAf.mjs";
import { O as ve } from "./OrMenuItem-BHRMA0L1.mjs";
import { O as ge } from "./OrMenu-CJT4Snay.mjs";
const Te = (e, t, i) => typeof t == "function" ? t(e, i) : e.toLocaleString(i, {
  dateStyle: t,
  timeZone: "UTC"
}), be = (e, t, i) => e.toLocaleString(i, {
  dateStyle: "medium",
  timeZone: "UTC"
}), he = (e, t, i) => e.toLocaleString(i, {
  timeStyle: "short",
  hourCycle: typeof t != "function" && t !== Y.Auto ? t : void 0,
  timeZone: "UTC"
}), Ce = (e, t, i) => typeof t == "function" ? t(e, i) : e.toLocaleString(i, {
  timeStyle: "short",
  hourCycle: t !== Y.Auto ? t : void 0,
  timeZone: "UTC"
}), K = () => {
  const e = /* @__PURE__ */ new Date();
  return new Date(Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate()
  ));
}, J = (e, t) => {
  const i = e.getBoundingClientRect(), m = t.getBoundingClientRect();
  i.top >= m.top && i.bottom <= m.bottom || (t.scrollTop = e.offsetTop - t.offsetTop - t.clientHeight / 2 + e.clientHeight / 2);
}, De = [
  // Layout
  "layout-inline-row",
  // Interactivity
  "interactivity-click",
  // Theme (focus)
  "focus-visible:theme-border-inherit focus-visible:border-b-2",
  "dark:focus-visible:theme-border-inherit-dark",
  // Theme (selected)
  "selected:theme-border-inherit selected:border-b-2",
  "dark:selected:theme-border-inherit-dark"
], ke = [
  // Theme
  "theme-foreground-outline",
  "dark:theme-foreground-outline-dark"
], Se = w({
  name: "OrDateTimePickerDateControl",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: void 0,
      default: void 0
    },
    format: {
      type: [String, Function],
      required: !0
    },
    locale: {
      type: String,
      required: !0
    },
    selected: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  expose: [
    "root"
  ],
  setup(e, t) {
    const i = f(), m = n(() => [
      "or-date-time-picker-date-control-v3",
      ...De
    ]), c = n(() => [
      ...ke
    ]), g = R(P(e, "modelValue"), t.emit), l = ae(P(e, "format"), P(e, "locale"));
    return {
      root: i,
      rootStyles: m,
      placeholderStyles: c,
      model: g,
      placeholder: l,
      formatDate: Te
    };
  }
}), Ue = ["contenteditable", "selected", "required", "readonly", "disabled"], Me = ["disabled"];
function Fe(e, t, i, m, c, g) {
  return p(), T("div", {
    ref: "root",
    class: v(e.rootStyles),
    contenteditable: !e.disabled,
    selected: e.selected,
    required: e.required,
    readonly: e.readonly,
    disabled: e.disabled,
    onKeydown: t[0] || (t[0] = D(() => {
    }, ["prevent"]))
  }, [
    e.model ? (p(), T(G, { key: 0 }, [
      k(V(e.formatDate(e.model, e.format, e.locale)), 1)
    ], 64)) : (p(), T("span", {
      key: 1,
      class: v(e.placeholderStyles),
      disabled: e.disabled
    }, V(e.placeholder), 11, Me))
  ], 42, Ue);
}
const Pe = /* @__PURE__ */ q(Se, [["render", Fe]]), Ve = [
  // Layout
  "layout-column",
  // Spacing
  "px-md",
  "py-md",
  "gap-sm"
], Oe = [
  // Layout
  "grid content-start",
  "grid-cols-7",
  // Box
  "h-[262px]",
  // Spacing
  "-mx-[2px]",
  "-my-[2px]"
], $e = [
  // Layout
  "layout-row justify-center",
  // Interactivity
  "interactivity-default",
  // Spacing
  "mx-[2px]",
  "my-[2px]",
  "px-sm",
  "py-sm",
  // Typography
  "typography-caption-regular",
  // Theme
  "theme-foreground-outline",
  "dark:theme-foreground-outline-dark"
], Be = [
  // Box
  "!min-w-fit",
  // Spacing
  "mx-[2px]",
  "my-[2px]",
  "!px-sm",
  "!py-sm",
  // Typography
  "typography-caption-regular"
], Ne = [
  // Theme
  "theme-foreground-primary",
  "dark:theme-foreground-primary-dark",
  "theme-outline-primary outline-1",
  "dark:theme-outline-primary-dark"
], we = [
  // Spacing
  "!mx-0",
  "!px-[10px]",
  // Shape
  "!rounded-0",
  // Theme
  "theme-background-primary-translucent-2",
  "dark:theme-background-primary-translucent-2-dark"
], Ie = w({
  name: "OrDateTimePickerDateSelect",
  components: {
    OrButton: W
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: void 0,
      default: void 0
    },
    initialValue: {
      type: Date,
      required: !0
    },
    format: {
      type: [String, Function],
      required: !0
    },
    locale: {
      type: String,
      required: !0
    },
    dateFilter: {
      type: Function,
      default: void 0
    },
    rangeStart: {
      type: Date,
      default: void 0
    },
    rangeEnd: {
      type: Date,
      default: void 0
    }
  },
  emits: [
    "update:modelValue"
  ],
  expose: [
    "root"
  ],
  setup(e, t) {
    const i = f(), m = n(() => [
      "or-date-time-picker-date-select-v3",
      ...Ve
    ]), c = n(() => [
      ...Oe
    ]), g = n(() => [
      ...$e
    ]), l = n(() => [
      ...Be
    ]), o = n(() => [
      ...Ne
    ]), S = n(() => [
      ...we
    ]), M = R(P(e, "modelValue"), t.emit), a = n(() => {
      const y = new Date(Date.UTC(
        e.initialValue.getUTCFullYear(),
        e.initialValue.getUTCMonth(),
        1,
        e.initialValue.getUTCHours(),
        e.initialValue.getUTCMinutes()
      )), O = new Date(Date.UTC(
        e.initialValue.getUTCFullYear(),
        e.initialValue.getUTCMonth() + 1,
        0,
        e.initialValue.getUTCHours(),
        e.initialValue.getUTCMinutes()
      )), $ = new Date(Date.UTC(
        y.getUTCFullYear(),
        y.getUTCMonth(),
        1 - y.getUTCDay(),
        y.getUTCHours(),
        y.getUTCMinutes()
      )), C = new Date(Date.UTC(
        O.getUTCFullYear(),
        O.getUTCMonth() + 1,
        7 - O.getUTCDay(),
        O.getUTCHours(),
        O.getUTCMinutes()
      ));
      return (() => {
        let B = [], r = $;
        for (; Number(r) !== Number(C); )
          B = [...B, r], r = new Date(Date.UTC(
            r.getUTCFullYear(),
            r.getUTCMonth(),
            r.getUTCDate() + 1,
            r.getUTCHours(),
            r.getUTCMinutes()
          ));
        return B;
      })();
    }), d = n(() => {
      const y = /* @__PURE__ */ new Date();
      return y.setUTCHours(e.initialValue.getUTCHours()), y.setUTCMinutes(e.initialValue.getUTCMinutes()), y.setUTCSeconds(e.initialValue.getUTCSeconds()), y.setUTCMilliseconds(e.initialValue.getUTCMilliseconds()), y;
    });
    function u(y) {
      return y.toLocaleString(e.locale, {
        weekday: "short",
        timeZone: "UTC"
      });
    }
    function I(y) {
      return y.toLocaleString(e.locale, {
        day: "numeric",
        timeZone: "UTC"
      });
    }
    return {
      root: i,
      rootStyles: m,
      buttonGroupStyles: c,
      buttonGroupWeekdayItemStyles: g,
      buttonGroupDateItemStyles: l,
      buttonGroupCurrentDateItemStyles: o,
      buttonGroupInRangeDateItemStyles: S,
      model: M,
      dayOptions: a,
      currentDate: d,
      formatWeekday: u,
      formatDay: I
    };
  }
});
function He(e, t, i, m, c, g) {
  const l = N("OrButton");
  return p(), T("div", {
    ref: "root",
    class: v(e.rootStyles)
  }, [
    E("div", {
      class: v(e.buttonGroupStyles)
    }, [
      (p(), T(G, null, L(7, (o) => E("div", {
        key: o,
        class: v(e.buttonGroupWeekdayItemStyles)
      }, V(e.formatWeekday(e.dayOptions[o - 1])), 3)), 64)),
      (p(!0), T(G, null, L(e.dayOptions, (o) => (p(), A(l, {
        key: Number(o),
        class: v({
          [e.buttonGroupDateItemStyles.join(" ")]: !0,
          [e.buttonGroupCurrentDateItemStyles.join(" ")]: Number(o) !== Number(e.model) && Number(o) !== Number(e.rangeStart) && Number(o) !== Number(e.rangeEnd) && Number(o) === Number(e.currentDate),
          [e.buttonGroupInRangeDateItemStyles.join(" ")]: e.rangeStart && Number(o) > Number(e.rangeStart) && e.rangeEnd && Number(o) < Number(e.rangeEnd)
        }),
        variant: Number(o) === Number(e.model) || e.rangeStart && Number(o) === Number(e.rangeStart) || e.rangeEnd && Number(o) === Number(e.rangeEnd) ? "contained" : "text",
        color: Number(o) === Number(e.model) || e.rangeStart && Number(o) === Number(e.rangeStart) || e.rangeEnd && Number(o) === Number(e.rangeEnd) ? "primary" : "inherit",
        disabled: e.dateFilter && !e.dateFilter(o),
        onClick: D((S) => e.model = o, ["stop"])
      }, {
        default: U(() => [
          k(V(e.formatDay(o)), 1)
        ]),
        _: 2
      }, 1032, ["class", "variant", "color", "disabled", "onClick"]))), 128))
    ], 2)
  ], 2);
}
const Ge = /* @__PURE__ */ q(Ie, [["render", He]]), qe = [
  // Layout
  "layout-column",
  // Interactivity
  "interactivity-auto",
  // Spacing
  "gap-xs",
  // Theme
  "theme-foreground-outline",
  "dark:theme-foreground-outline-dark",
  // Theme (selected)
  "selected:theme-foreground-default",
  "dark:selected:theme-foreground-default-dark"
], Ye = [
  // Typography
  "typography-headline-1"
], Ee = w({
  name: "OrDateTimePickerMobileControl",
  components: {
    OrLabel: x
  },
  props: {
    label: {
      type: String,
      required: !0
    },
    selected: {
      type: Boolean,
      default: !1
    }
  },
  expose: [
    "root"
  ],
  setup() {
    const e = f(), t = n(() => [
      "or-date-time-picker-mobile-control-v3",
      ...qe
    ]), i = n(() => [
      ...Ye
    ]);
    return {
      root: e,
      rootStyles: t,
      contentStyles: i
    };
  }
}), Le = ["selected"];
function Re(e, t, i, m, c, g) {
  const l = N("OrLabel");
  return p(), T("div", {
    ref: "root",
    class: v(e.rootStyles),
    selected: e.selected
  }, [
    F(l, null, {
      default: U(() => [
        k(V(e.label), 1)
      ]),
      _: 1
    }),
    E("div", {
      class: v(e.contentStyles)
    }, [
      Q(e.$slots, "default")
    ], 2)
  ], 10, Le);
}
const Ae = /* @__PURE__ */ q(Ee, [["render", Re]]), Ze = [
  // Layout
  "layout-row justify-between",
  // Spacing
  "px-md",
  "py-md",
  "gap-md"
], je = w({
  name: "OrDateTimePickerMonthSelect",
  components: {
    OrButton: W,
    OrIcon: _,
    OrIconButton: X,
    OrMenu: ge,
    OrMenuItem: ve
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: void 0,
      required: !0
    },
    locale: {
      type: String,
      required: !0
    },
    yearFilter: {
      type: Function,
      default: void 0
    },
    monthFilter: {
      type: Function,
      default: void 0
    }
  },
  emits: [
    "update:modelValue"
  ],
  expose: [
    "root"
  ],
  setup(e, t) {
    const i = f(), m = n(() => [
      "or-date-time-picker-month-select-v3",
      ...Ze
    ]), c = f(), g = n(() => {
      var r;
      return (r = c.value) == null ? void 0 : r.root;
    }), l = f(), o = n(() => {
      var r;
      return (r = l.value) == null ? void 0 : r.root;
    }), S = f(), M = n(() => {
      var r;
      return (r = S.value) == null ? void 0 : r.state;
    }), a = f(), d = n(() => {
      var r;
      return (r = a.value) == null ? void 0 : r.state;
    }), u = R(P(e, "modelValue"), t.emit), I = n(() => Array.from({ length: 11 }).map((r, b, { length: h }) => {
      const H = u.value.getUTCFullYear() - Math.floor(h / 2) + b;
      return new Date(Date.UTC(
        H,
        u.value.getUTCMonth(),
        u.value.getUTCDate(),
        u.value.getUTCHours(),
        u.value.getUTCMinutes()
      ));
    })), y = n(() => Array.from({ length: 12 }, (r, b) => {
      const h = b;
      return new Date(Date.UTC(
        u.value.getUTCFullYear(),
        h,
        u.value.getUTCDate(),
        u.value.getUTCHours(),
        u.value.getUTCMinutes()
      ));
    }));
    function O() {
      u.value = new Date(Date.UTC(
        u.value.getUTCFullYear(),
        u.value.getUTCMonth() + 1,
        u.value.getUTCDate(),
        u.value.getUTCHours(),
        u.value.getUTCMinutes()
      ));
    }
    function $() {
      u.value = new Date(Date.UTC(
        u.value.getUTCFullYear(),
        u.value.getUTCMonth() - 1,
        u.value.getUTCDate(),
        u.value.getUTCHours(),
        u.value.getUTCMinutes()
      ));
    }
    function C(r) {
      return r.toLocaleString(e.locale, {
        year: "numeric",
        timeZone: "UTC"
      });
    }
    function B(r) {
      return r.toLocaleString(e.locale, {
        month: "long",
        timeZone: "UTC"
      });
    }
    return {
      root: i,
      rootStyles: m,
      yearButton: c,
      yearButtonRoot: g,
      monthButton: l,
      monthButtonRoot: o,
      yearMenu: S,
      yearMenuState: M,
      monthMenu: a,
      monthMenuState: d,
      model: u,
      yearOptions: I,
      monthOptions: y,
      goToNextMonth: O,
      goToPreviousMonth: $,
      formatYear: C,
      formatMonth: B
    };
  }
}), We = {
  class: /* @__PURE__ */ v(["layout-row-reverse", "gap-md"])
};
function ze(e, t, i, m, c, g) {
  const l = N("OrIconButton"), o = N("OrIcon"), S = N("OrButton"), M = N("OrMenuItem"), a = N("OrMenu");
  return p(), T("div", {
    ref: "root",
    class: v(e.rootStyles)
  }, [
    F(l, {
      icon: "chevron_left",
      onClick: t[0] || (t[0] = D((d) => e.goToPreviousMonth(), ["stop"]))
    }),
    E("div", We, [
      F(S, {
        ref: "yearButton",
        variant: "link",
        color: "inherit",
        onClick: t[1] || (t[1] = D((d) => {
          e.monthMenu && e.monthMenu.close(), e.yearMenu && e.yearMenu.toggle();
        }, ["stop"]))
      }, {
        default: U(() => [
          k(V(e.formatYear(e.model)) + " ", 1),
          F(o, {
            icon: e.yearMenuState === "open" ? "arrow_drop_up" : "arrow_drop_down"
          }, null, 8, ["icon"])
        ]),
        _: 1
      }),
      F(S, {
        ref: "monthButton",
        variant: "link",
        color: "inherit",
        onClick: t[2] || (t[2] = D((d) => {
          e.yearMenu && e.yearMenu.close(), e.monthMenu && e.monthMenu.toggle();
        }, ["stop"]))
      }, {
        default: U(() => [
          k(V(e.formatMonth(e.model)) + " ", 1),
          F(o, {
            icon: e.monthMenuState === "open" ? "arrow_drop_up" : "arrow_drop_down"
          }, null, 8, ["icon"])
        ]),
        _: 1
      }),
      F(a, {
        ref: "yearMenu",
        trigger: e.yearButtonRoot
      }, {
        default: U(() => [
          (p(!0), T(G, null, L(e.yearOptions, (d) => (p(), A(M, {
            key: Number(d),
            selected: Number(d) === Number(e.model),
            disabled: e.yearFilter && !e.yearFilter(d),
            onClick: D((u) => {
              e.model = d, e.yearMenu && e.yearMenu.close();
            }, ["stop"])
          }, {
            default: U(() => [
              k(V(e.formatYear(d)), 1)
            ]),
            _: 2
          }, 1032, ["selected", "disabled", "onClick"]))), 128))
        ]),
        _: 1
      }, 8, ["trigger"]),
      F(a, {
        ref: "monthMenu",
        trigger: e.monthButtonRoot
      }, {
        default: U(() => [
          (p(!0), T(G, null, L(e.monthOptions, (d) => (p(), A(M, {
            key: Number(d),
            selected: Number(d) === Number(e.model),
            disabled: e.monthFilter && !e.monthFilter(d),
            onClick: D((u) => {
              e.model = d, e.monthMenu && e.monthMenu.close();
            }, ["stop"])
          }, {
            default: U(() => [
              k(V(e.formatMonth(d)), 1)
            ]),
            _: 2
          }, 1032, ["selected", "disabled", "onClick"]))), 128))
        ]),
        _: 1
      }, 8, ["trigger"])
    ]),
    F(l, {
      icon: "chevron_right",
      onClick: t[3] || (t[3] = D((d) => e.goToNextMonth(), ["stop"]))
    })
  ], 2);
}
const Ke = /* @__PURE__ */ q(je, [["render", ze]]), Je = [
  // Layout
  "layout-row-reverse",
  // Layout (children)
  "children:grow",
  // Spacing
  "px-md md:px-sm",
  "py-md md:py-sm",
  "gap-md md:gap-sm",
  // Theme
  "theme-border-outline-variant border-t-1",
  "dark:theme-border-outline-variant-dark"
], Qe = w({
  name: "OrDateTimePickerPopoverFooter",
  components: {
    OrButton: W
  },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "apply",
    "reset"
  ],
  expose: [
    "root"
  ],
  setup() {
    const e = f(), t = n(() => [
      "or-date-time-picker-popover-footer-v3",
      ...Je
    ]);
    return {
      root: e,
      rootStyles: t
    };
  }
});
function Xe(e, t, i, m, c, g) {
  const l = N("OrButton");
  return p(), T("footer", {
    ref: "root",
    class: v(e.rootStyles)
  }, [
    F(l, {
      variant: "outlined",
      disabled: e.disabled,
      onClick: t[0] || (t[0] = D((o) => e.$emit("apply"), ["stop"]))
    }, {
      default: U(() => [
        k(" Done ")
      ]),
      _: 1
    }, 8, ["disabled"]),
    F(l, {
      variant: "text",
      onClick: t[1] || (t[1] = D((o) => e.$emit("reset"), ["stop"]))
    }, {
      default: U(() => [
        k(" Cancel ")
      ]),
      _: 1
    })
  ], 2);
}
const _e = /* @__PURE__ */ q(Qe, [["render", Xe]]), xe = [
  // Layout
  "layout-row md:hidden",
  // Spacing
  "px-md",
  "py-md",
  "gap-xl"
], et = w({
  name: "OrDateTimePickerPopoverHeader",
  expose: [
    "root"
  ],
  setup() {
    const e = f(), t = n(() => [
      "or-date-time-picker-popover-header-v3",
      ...xe
    ]);
    return {
      root: e,
      rootStyles: t
    };
  }
});
function tt(e, t, i, m, c, g) {
  return p(), T("header", {
    ref: "root",
    class: v(e.rootStyles)
  }, [
    Q(e.$slots, "default")
  ], 2);
}
const ot = /* @__PURE__ */ q(et, [["render", tt]]), rt = [
  // Layout
  "layout-inline-row",
  // Interactivity
  "interactivity-click",
  // Theme (focus)
  "focus-visible:theme-border-inherit focus-visible:border-b-2",
  "dark:focus-visible:theme-border-inherit-dark",
  // Theme (selected)
  "selected:theme-border-inherit selected:border-b-2",
  "dark:selected:theme-border-inherit-dark"
], nt = [
  // Theme
  "theme-foreground-outline",
  "dark:theme-foreground-outline-dark"
], at = w({
  name: "OrDateTimePickerTimeControl",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: void 0,
      default: void 0
    },
    format: {
      type: [String, Function],
      required: !0
    },
    locale: {
      type: String,
      required: !0
    },
    selected: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  expose: [
    "root"
  ],
  setup(e, t) {
    const i = f(), m = n(() => [
      "or-date-time-picker-time-control-v3",
      ...rt
    ]), c = n(() => [
      ...nt
    ]), g = R(P(e, "modelValue"), t.emit), l = ie(P(e, "format"), P(e, "locale"));
    return {
      root: i,
      rootStyles: m,
      placeholderStyles: c,
      model: g,
      placeholder: l,
      formatTime: Ce
    };
  }
}), it = ["contenteditable", "selected", "required", "readonly", "disabled"], lt = ["disabled"];
function ut(e, t, i, m, c, g) {
  return p(), T("div", {
    ref: "root",
    class: v(e.rootStyles),
    contenteditable: !e.disabled,
    selected: e.selected,
    required: e.required,
    readonly: e.readonly,
    disabled: e.disabled,
    onKeydown: t[0] || (t[0] = D(() => {
    }, ["prevent"]))
  }, [
    e.model ? (p(), T(G, { key: 0 }, [
      k(V(e.formatTime(e.model, e.format, e.locale)), 1)
    ], 64)) : (p(), T("span", {
      key: 1,
      class: v(e.placeholderStyles),
      disabled: e.disabled
    }, V(e.placeholder), 11, lt))
  ], 42, it);
}
const st = /* @__PURE__ */ q(at, [["render", ut]]), dt = [
  // Layout
  "layout-row justify-center",
  // Spacing
  "px-md",
  "py-md",
  "gap-sm",
  // Typography
  "typography-body-2-regular",
  // Theme
  "theme-foreground-default",
  "dark:theme-foreground-default-dark"
], mt = [
  // Layout
  "layout-column",
  // Box
  "h-[294px] md:h-[238px]",
  // Overflow
  "overflow-x-hidden",
  "overflow-y-auto"
], ct = [
  // Box
  "!min-w-fit",
  // Typography
  "typography-caption-regular"
], pt = w({
  name: "OrDateTimePickerTimeSelect",
  components: {
    OrButton: W
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: void 0,
      default: void 0
    },
    initialValue: {
      type: Date,
      required: !0
    },
    format: {
      type: [String, Function],
      required: !0
    },
    locale: {
      type: String,
      required: !0
    },
    hoursFilter: {
      type: Function,
      default: void 0
    },
    minutesFilter: {
      type: Function,
      default: void 0
    },
    hourStep: {
      type: Number,
      default: 1
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    isActive: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue"
  ],
  expose: [
    "root"
  ],
  setup(e, t) {
    const i = f(), m = f(), c = f(), g = f([]), l = f([]), o = n(() => [
      "or-date-time-picker-time-select-v3",
      ...dt
    ]), S = n(() => [
      ...mt
    ]), M = n(() => [
      ...ct
    ]), a = R(P(e, "modelValue"), t.emit), d = f((a.value ?? e.initialValue).getUTCHours() < 12 ? "am" : "pm");
    j(d, (r) => {
      switch (r) {
        case "am":
          a.value = new Date(Date.UTC(
            (a.value ?? e.initialValue).getUTCFullYear(),
            (a.value ?? e.initialValue).getUTCMonth(),
            (a.value ?? e.initialValue).getUTCDate(),
            (a.value ?? e.initialValue).getUTCHours() - 12,
            (a.value ?? e.initialValue).getUTCMinutes()
          ));
          break;
        case "pm":
          a.value = new Date(Date.UTC(
            (a.value ?? e.initialValue).getUTCFullYear(),
            (a.value ?? e.initialValue).getUTCMonth(),
            (a.value ?? e.initialValue).getUTCDate(),
            (a.value ?? e.initialValue).getUTCHours() + 12,
            (a.value ?? e.initialValue).getUTCMinutes()
          ));
          break;
      }
    }), j(() => e.isActive, (r) => {
      te(() => {
        if (!r || !a.value)
          return;
        const b = B(g.value, I.value), h = B(l.value, y.value);
        b && m.value && J(b, m.value), h && c.value && J(h, c.value);
      });
    }, { immediate: !0 });
    const u = n(() => typeof e.format == "function" || e.format === Y.Auto ? new Date(1970, 0).toLocaleTimeString(e.locale).includes("12") ? Y.H12 : Y.H23 : e.format), I = n(() => {
      const r = e.hourStep > 0 ? e.hourStep : 1;
      return Array.from({ length: Math.ceil(24 / r) }, (b, h) => {
        const H = h * r;
        return new Date(Date.UTC(
          (a.value ?? e.initialValue).getUTCFullYear(),
          (a.value ?? e.initialValue).getUTCMonth(),
          (a.value ?? e.initialValue).getUTCDate(),
          H,
          (a.value ?? e.initialValue).getUTCMinutes()
        ));
      }).filter((b) => {
        if (u.value === Y.H23)
          return !0;
        switch (d.value) {
          case "am":
            return b.getUTCHours() < 12;
          case "pm":
            return b.getUTCHours() >= 12;
        }
      });
    }), y = n(() => {
      const r = e.minuteStep > 0 ? e.minuteStep : 1;
      return Array.from({ length: Math.ceil(60 / r) }, (b, h) => {
        const H = h * r;
        return new Date(Date.UTC(
          (a.value ?? e.initialValue).getUTCFullYear(),
          (a.value ?? e.initialValue).getUTCMonth(),
          (a.value ?? e.initialValue).getUTCDate(),
          (a.value ?? e.initialValue).getUTCHours(),
          H
        ));
      });
    });
    function O(r) {
      return r.toLocaleString(e.locale, {
        hour: "numeric",
        hourCycle: typeof e.format != "function" && e.format !== Y.Auto ? e.format : void 0,
        timeZone: "UTC"
      }).replace(/\D/g, "");
    }
    function $(r) {
      return String(r.getUTCMinutes()).padStart(2, "0");
    }
    function C(r) {
      return [...r].sort((b, h) => b.root.compareDocumentPosition(h.root) & 2 ? 1 : -1);
    }
    function B(r, b) {
      var h;
      return (h = C(r).find((H, Z) => Number(a.value) === Number(b[Z]))) == null ? void 0 : h.root;
    }
    return {
      root: i,
      rootStyles: o,
      hoursContainer: m,
      minutesContainer: c,
      hoursButtons: g,
      minutesButtons: l,
      buttonGroupStyles: S,
      buttonGroupItemStyles: M,
      model: a,
      dayPeriod: d,
      proxyTimeFormat: u,
      hoursOptions: I,
      minutesOptions: y,
      formatHours: O,
      formatMinutes: $
    };
  }
});
function ft(e, t, i, m, c, g) {
  const l = N("OrButton");
  return p(), T("div", {
    ref: "root",
    class: v(e.rootStyles)
  }, [
    E("div", {
      ref: "hoursContainer",
      class: v(e.buttonGroupStyles)
    }, [
      (p(!0), T(G, null, L(e.hoursOptions, (o) => (p(), A(l, {
        ref_for: !0,
        ref: "hoursButtons",
        key: Number(o),
        class: v(e.buttonGroupItemStyles),
        variant: Number(o) === Number(e.model) ? "contained" : "text",
        color: Number(o) === Number(e.model) ? "primary" : "inherit",
        disabled: e.hoursFilter && !e.hoursFilter(o),
        onClick: D((S) => e.model = o, ["stop"])
      }, {
        default: U(() => [
          k(V(e.formatHours(o)), 1)
        ]),
        _: 2
      }, 1032, ["class", "variant", "color", "disabled", "onClick"]))), 128))
    ], 2),
    k(" : "),
    E("div", {
      ref: "minutesContainer",
      class: v(e.buttonGroupStyles)
    }, [
      (p(!0), T(G, null, L(e.minutesOptions, (o) => (p(), A(l, {
        ref_for: !0,
        ref: "minutesButtons",
        key: Number(o),
        class: v(e.buttonGroupItemStyles),
        variant: Number(o) === Number(e.model) ? "contained" : "text",
        color: Number(o) === Number(e.model) ? "primary" : "inherit",
        disabled: e.minutesFilter && !e.minutesFilter(o),
        onClick: D((S) => e.model = o, ["stop"])
      }, {
        default: U(() => [
          k(V(e.formatMinutes(o)), 1)
        ]),
        _: 2
      }, 1032, ["class", "variant", "color", "disabled", "onClick"]))), 128))
    ], 2),
    e.proxyTimeFormat === "h12" ? (p(), T("div", {
      key: 0,
      class: v(e.buttonGroupStyles)
    }, [
      F(l, {
        class: v(e.buttonGroupItemStyles),
        variant: e.dayPeriod === "am" ? "contained" : "text",
        color: e.dayPeriod === "am" ? "primary" : "inherit",
        onClick: t[0] || (t[0] = D((o) => e.dayPeriod = "am", ["stop"]))
      }, {
        default: U(() => [
          k(" AM ")
        ]),
        _: 1
      }, 8, ["class", "variant", "color"]),
      F(l, {
        class: v(e.buttonGroupItemStyles),
        variant: e.dayPeriod === "pm" ? "contained" : "text",
        color: e.dayPeriod === "pm" ? "primary" : "inherit",
        onClick: t[1] || (t[1] = D((o) => e.dayPeriod = "pm", ["stop"]))
      }, {
        default: U(() => [
          k(" PM ")
        ]),
        _: 1
      }, 8, ["class", "variant", "color"])
    ], 2)) : oe("", !0)
  ], 2);
}
const yt = /* @__PURE__ */ q(pt, [["render", ft]]), vt = [
  // Layout
  "layout-column",
  // Spacing
  "gap-xs"
], gt = [
  // Box
  "w-[290px]"
], Tt = [], Ht = w({
  name: "OrDateTimePicker",
  components: {
    OrDateTimePickerDateControl: Pe,
    OrDateTimePickerDateSelect: Ge,
    OrDateTimePickerMobileControl: Ae,
    OrDateTimePickerMonthSelect: Ke,
    OrDateTimePickerPopoverFooter: _e,
    OrDateTimePickerPopoverHeader: ot,
    OrDateTimePickerTimeControl: st,
    OrDateTimePickerTimeSelect: yt,
    OrError: me,
    OrHint: ce,
    OrIcon: _,
    OrIconButton: X,
    OrInputBox: pe,
    OrLabel: x,
    OrPopover: ye
  },
  directives: {
    DropdownClose: re,
    DropdownOpen: ne
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: void 0,
      default: void 0
    },
    dateFormat: {
      type: [String, Function],
      default: void 0
    },
    timeFormat: {
      type: [String, Function],
      default: void 0
    },
    locale: {
      type: String,
      default: void 0
    },
    yearFilter: {
      type: Function,
      default: void 0
    },
    monthFilter: {
      type: Function,
      default: void 0
    },
    dateFilter: {
      type: Function,
      default: void 0
    },
    hoursFilter: {
      type: Function,
      default: void 0
    },
    minutesFilter: {
      type: Function,
      default: void 0
    },
    hourStep: {
      type: Number,
      default: 1
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    variant: {
      type: String,
      default: void 0
    },
    size: {
      type: String,
      default: void 0
    },
    anchor: {
      type: Object,
      default: void 0
    },
    label: {
      type: String,
      default: void 0
    },
    hint: {
      type: String,
      default: void 0
    },
    error: {
      type: [String, Boolean],
      default: void 0
    },
    required: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue",
    "input",
    "keydown",
    "keyup",
    "focus",
    "blur"
  ],
  expose: [
    "root",
    "focus",
    "blur"
  ],
  setup(e, t) {
    const i = f(), m = n(() => [
      "or-date-time-picker-v3",
      ...vt,
      ...e.variant === fe.Embedded ? ["grow"] : []
    ]), c = f(), g = n(() => {
      var s;
      return (s = c.value) == null ? void 0 : s.root;
    }), l = f(), o = n(() => {
      var s;
      return (s = l.value) == null ? void 0 : s.state;
    }), S = n(() => [
      "or-date-time-picker-date-popover-v3",
      ...ee.value ? [] : gt
    ]), M = f(), a = n(() => {
      var s;
      return (s = M.value) == null ? void 0 : s.state;
    }), d = n(() => [
      "or-date-time-picker-time-popover-v3",
      ...Tt
    ]), u = le(P(e, "dateFormat")), I = ue(P(e, "timeFormat")), y = se(P(e, "locale")), O = f(e.modelValue ?? K());
    j(() => e.modelValue, (s) => {
      O.value = s ?? K();
    });
    const $ = R(P(e, "modelValue"), t.emit), C = f($.value);
    j($, (s) => {
      C.value = s;
    });
    const B = n(() => C.value ? !!(e.yearFilter && !e.yearFilter(C.value) || e.monthFilter && !e.monthFilter(C.value) || e.dateFilter && !e.dateFilter(C.value) || e.hoursFilter && !e.hoursFilter(C.value) || e.minutesFilter && !e.minutesFilter(C.value)) : !0);
    function r() {
      $.value = C.value;
    }
    function b() {
      C.value = $.value;
    }
    function h() {
      if (!e.readonly && !e.disabled) {
        const s = l.value;
        s && (o.value === "open" ? s.close() : s.open()), z();
      }
    }
    function H() {
      if (!e.readonly && !e.disabled) {
        const s = M.value;
        s && (a.value === "open" ? s.close() : s.open()), Z();
      }
    }
    function Z() {
      const s = l.value;
      s && s.close();
    }
    function z() {
      const s = M.value;
      s && s.close();
    }
    const { isMobile: ee } = de();
    return {
      root: i,
      rootStyles: m,
      inputBox: c,
      inputBoxRoot: g,
      datePopover: l,
      datePopoverState: o,
      datePopoverStyles: S,
      timePopover: M,
      timePopoverState: a,
      timePopoverStyles: d,
      resolvedDateFormat: u,
      resolvedTimeFormat: I,
      resolvedLocale: y,
      initialValue: O,
      model: $,
      draft: C,
      invalid: B,
      apply: r,
      reset: b,
      toggleDatePopover: h,
      toggleTimePopover: H,
      closeDatePopover: Z,
      closeTimePopover: z,
      formatMobileDate: be,
      formatMobileTime: he
    };
  }
});
export {
  Pe as O,
  Ht as _,
  Ge as a,
  Ae as b,
  Ke as c,
  _e as d,
  ot as e,
  st as f,
  yt as g,
  Te as h,
  be as i,
  he as j,
  Ce as k,
  K as l,
  J as s
};
//# sourceMappingURL=OrDateTimePicker.vue_vue_type_script_lang-kFeSOigY.mjs.map
